import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { homePageJson } from '@/views/system/member/typings';

export interface HomeMemberState extends homePageJson {
  timeOut: string;
  uid: number;
}

const MEMBER_KEY = 'React-ts-ant-homeMember';

const localHomeMembers = LocalStore.getValue<HomeMemberState>(MEMBER_KEY) || {};

export const defaults: HomeMemberState = {
  balance: 0,
  days: 0,
  end_date: '',
  game_count: 0,
  head_img: '',
  nick_name: '',
  price: 0,
  receive_explain: '',
  remain_coupons: 0,
  rights_count: 0,
  rights_list: [],
  // rights_switch: number;
  rule: '',
  send_coupon: 0,
  sign_explain: '',
  sign_list: [],
  // total_coupons: number;
  vip_date: '',
  vip_end_ts: 0,
  vip_state: 0,
  timeOut: '',
  uid: 0,
  ...localHomeMembers
};

const HOME_MEMBER_KEY = 'React-ts-ant-HOMEMEMBER';

export const updateHomeMember: (homePages: HomeMemberState) => IAction<HomeMemberState> = (
  homePages: HomeMemberState
) => ({
  type: HOME_MEMBER_KEY,
  payload: homePages
});

const homeMemberReducer: Reducer<HomeMemberState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_MEMBER_KEY:
      LocalStore.setValue(MEMBER_KEY, payload as HomeMemberState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeMemberReducer;
